var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"}},[_c('path',{attrs:{"d":"M3.33333 5.6665L8 10.3332L12.6667 5.6665H3.33333Z","fill":_vm.fill,"fill-opacity":"0.6"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }